<template>
  <v-row>
    <template v-if="currentDays.length > 0">
      <v-col cols="12" ><h1 class="text-h2 px-8">Content</h1></v-col>
      <v-col cols="12">
        <v-row v-for="day in currentDays" :key="day">
          <v-col cols="12" class="text-uppercase px-16 font-weight-semibold">{{new Date(day).toLocaleDateString($language.current, { month: 'long', day: 'numeric' })}}</v-col>
          <v-col cols="12">
            <ScrollGallery
              :data="currentDayEvents(day)"
              :cols="$vuetify.breakpoint.xl ? 3 : $vuetify.breakpoint.lgAndUp ? 4 : $vuetify.breakpoint.mdAndUp ? 5 : $vuetify.breakpoint.smAndUp ? 8 : 10" />
          </v-col>
        </v-row>
        <!--  -->
      </v-col>
    </template>
    <template v-if="pastDays.length > 0">
      <v-col cols="12" ><h1 class="text-h2 px-8">Content 2020</h1></v-col>
      <v-col cols="12">
        <v-row v-for="day in pastDays" :key="day">
          <v-col cols="12" class="text-uppercase px-16 font-weight-semibold">{{new Date(day).toLocaleDateString($language.current, { month: 'long', day: 'numeric' })}}</v-col>
          <v-col cols="12">
            <ScrollGallery
              :data="pastDayEvents(day)"
              :cols="$vuetify.breakpoint.xl ? 3 : $vuetify.breakpoint.lgAndUp ? 4 : $vuetify.breakpoint.mdAndUp ? 5 : $vuetify.breakpoint.smAndUp ? 8 : 10" />
          </v-col>
        </v-row>
        <!--  -->
      </v-col>
    </template>
  </v-row>
</template>

<script>
import ScrollGallery from '@/molecules/ScrollGallery'
// import ListWorkshopsByTopic from '@/graphql/ListWorkshopsByTopic.gql'
// import ListTalksByTopic from '@/graphql/ListTalksByTopic.gql'
import uniq from 'lodash/uniq'
import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
// import reverse from 'lodash/reverse'
// import intersectionBy from 'lodash/intersectionBy'
// import TalkCard from '@/molecules/TalkCard'
import ListTalk from '@/graphql/ListTalk.gql'
import ListPastTalk from '@/graphql/ListPastTalk.gql'

export default {
  name: 'PastEvents',
  components: {
    ScrollGallery
    // TalkCard
  },
  computed: {
    currentDays () {
      if (this.Talks && this.Talks.items && this.Talks.items.length > 0) {
        const days = this.Talks.items.map(t => t.startingAt.split('T')[0])
        return sortBy(uniq(days))
      }
      return []
    },
    pastDays () {
      if (this.PastTalks && this.PastTalks.items && this.PastTalks.items.length > 0) {
        const days = filter(this.PastTalks.items, (t) => !!t.recordingYoutubeURL || !!t.recordingVimeoURL).map(t => t.startingAt.split('T')[0])
        return sortBy(uniq(days))
      }
      return []
    }
  },
  methods: {
    currentDayEvents (day) {
      if (this.Talks && this.Talks.items && this.Talks.items.length > 0) {
        return sortBy(filter(this.Talks.items, talk => (talk.startingAt.split('T')[0] === day)), ['startingAt'])
      }
      return []
    },
    pastDayEvents (day) {
      if (this.PastTalks && this.PastTalks.items && this.PastTalks.items.length > 0) {
        return sortBy(filter(this.PastTalks.items, talk => (talk.startingAt.split('T')[0] === day)), ['startingAt'])
      }
      return []
    }
  },
  apollo: {
    Talks: {
      query: ListTalk,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'endingAt',
          descending: true
          // filter: { field: 'endingAt', operator: 'lt', operand: this.$root.getNow().toISOString() }
        }
      }
    },
    PastTalks: {
      query: ListPastTalk,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: 'endingAt',
          descending: true
        }
      }
    }
  }
}
</script>
